import React, { useState } from 'react';
import { Button } from 'antd';
import classNames from 'classnames';
import { CloseXIcon } from 'icons';
import { useTranslations } from 'next-intl';

import { ITest } from 'modules/blok-test';

import { Modal, Segmented } from 'components';

interface IProps {
  onClose: () => void;
  open: boolean;
  data?: ITest[];
  title?: string;
  answeredIds: number[];
}

const TestProgressModal: React.FC<IProps> = ({ onClose, open, data, title, answeredIds }) => {
  const t = useTranslations();
  const [selectedIndex, setSelectedIndex] = useState(0);

  const options =
    data?.map((item, index) => ({
      label: item.name,
      value: index.toString()
    })) ?? [];

  const handleChange = (value: string) => {
    setSelectedIndex(parseInt(value, 10));
  };

  const currentTest = data?.[selectedIndex];

  return (
    <Modal
      footer={false}
      open={open}
      centered
      onClose={onClose}
      closeIcon={
        <div className="flex items-center justify-center rounded-full bg-gray-800 p-1">
          <CloseXIcon size="12" />
        </div>
      }
      width="421px"
      styles={{
        content: { padding: '16px', borderRadius: '12px' }
      }}
      title={<span className="text-lg">{title}</span>}
    >
      <div className="mt-5">
        <Segmented options={options} onChange={handleChange} labelPrefix={t('Fan')} />

        {currentTest && (
          <div className="mt-3 grid grid-cols-8 gap-2 md:grid-cols-10">
            {currentTest.questions.map((test, index) => (
              <div
                key={test.id}
                className={classNames('flex h-8 w-8 items-center justify-center rounded-full border font-bold', {
                  'border-green-500 text-green-500': answeredIds.includes(test.id),
                  'border-gray-400 text-gray-400': !answeredIds.includes(test.id)
                })}
              >
                {index + 1}
              </div>
            ))}
          </div>
        )}
      </div>

      <Button
        onClick={onClose}
        className="!mt-15 !py-4.5 !w-full !border-transparent !bg-gray-100 !font-semibold hover:!text-gray-500"
      >
        {t('davom_ettirish')}
      </Button>
    </Modal>
  );
};

export default TestProgressModal;
